export default __webpack_public_path__ + "static/media/Group_8417.483422f8.svg";